<template>
    <div class="templete_box">
        <div class="templete">
            <div class="search_box clearfix">
                 <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始日期"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
                </div>
                <el-input class="search_input search_inputBox" v-model="params.apply_sn" placeholder="申请单号" size="mini"></el-input> 
                <el-select class="search_select search_inputBox" v-model="params.status" multiple collapse-tags placeholder="申请状态" filterable @visible-change="getSelectOAList('status')">
                    <el-option v-for="list in selectMapC.status" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.types" multiple collapse-tags placeholder="申请类型"  @visible-change="getSelectList('officeTypes')">
                    <el-option v-for="list in selectMap.officeTypes" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.leave_people_id" multiple collapse-tags placeholder="申请人" filterable @visible-change="getSelectOAList('leave_people_id')">
                    <el-option v-for="list in selectMapC.leave_people_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.reviewer_id" multiple collapse-tags placeholder="审批人" @visible-change="getSelectOAList('reviewer_id')">
                    <el-option v-for="list in selectMapC.reviewer_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>           
                <el-input class="search_input search_inputBox" v-model="params.bale_no" placeholder="捆包号" size="mini"></el-input> 
                <el-input class="search_input search_inputBox" v-model="params.remark" placeholder="备注" size="mini"></el-input> 
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                </div>
                <!-- <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button> -->
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                    <!-- <span class="excel_btn"> <i class="settings-icon"></i> </span> -->
                    <!-- <span class="excel_btn" style="margin-left:10px;" v-if="module.indexOf(',customer-import,')!=-1" @click="importDialogVisible=!importDialogVisible"><i class="excel-icon"></i>excel导入</span> -->
                    <span class="excel_btn" v-if="module.indexOf(',customer-export,')!=-1" @click="exportExcelBill"><i class="excel-icon"></i>excel导出</span>
                </div>
            </div>
            <div class="btnList clearfix">
                <el-button class="funcPublicBtn funcPublicBtnChecked" icon="el-icon-plus" @click="openAddMatter()">新增申请</el-button>
                <el-button class="funcPublicBtn" v-if="module.indexOf(',office-leave-review,')!=-1" @click="Examine" icon="iconfont icon-tianshenpi iconButStyle">审批</el-button>
                <el-button class="funcPublicBtn" @click="batchDel" icon="iconfont icon-piliangshanchu iconButStyle">批量删除</el-button>
                <!-- <el-button class="funcPublicBtn" @click="bacthUpImg">上传图片</el-button> -->
                <el-button class="funcPublicBtn" @click="bacthUpFile" icon="iconfont icon-shangchuantupian iconButStyle">上传图片</el-button> 
            </div>
            <div class="tableBox">
                <tabletem :isSetCol="true" scene="office.list"  :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="selectChange" @rowClick="rowClick" @getTableEdit="edit" @getTableDelete="del" @relativefile="relativeFile"></tabletem>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
        <!--请假条START-->
        <el-dialog v-dialog-drag :visible.sync="leavetriDialog" class="eldialog eldialogLine" :modal="false" :title="updataType==2?'OA申请单':'修改OA申请单'" width="825px" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form ref="feeOutForm" :model="form_params" :rules="feeOutFormRlues" class="clearfix dialogFormB">
                    <div class="formItem">
                        <el-form-item  label="申请时间：" prop="operate_time">
                            <el-date-picker v-model="form_params.operate_time" type="date" placeholder="" size="mini"></el-date-picker>
                        </el-form-item>
                        <el-form-item  label=" 申请人：" prop="leave_people_id" @change="getLeave_people_id(form_params.leave_people_id)">
                            <el-select v-model="form_params.leave_people_id" @visible-change="getSelectList('officeUsers')">
                                <el-option v-for="list in selectMap.officeUsers" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item  label="申请类型：" prop="types">
                            <el-select v-model="form_params.types" @visible-change="getSelectList('officeTypes')">
                                <el-option v-for="list in selectMap.officeTypes" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item  label="请假天数：" prop="leave_long" v-if="form_params.types==1">
                            <el-input v-model="form_params.leave_long" type="number"></el-input>
                        </el-form-item>
                        <el-form-item  label="客户名称：" prop="customer_name" v-if="form_params.types==2">
                            <el-input v-model="form_params.customer_name"></el-input>
                        </el-form-item>
                        <!-- <el-form-item  label="关联单号：" prop="order_id" v-if="form_params.types==2" required>
                            <el-select v-model="form_params.order_id" @visible-change="getofficeOrderList(form_params.leave_people_id)">
                                <el-option v-for="list in officeOrderList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item> -->
                        <el-form-item  label="预支金额：" prop="amount" v-if="form_params.types==3">
                            <el-input v-model="form_params.amount" type="number"></el-input>
                        </el-form-item>
                        <el-form-item  label="报销金额：" prop="expense_amount" v-if="form_params.types==4">
                            <el-input v-model="form_params.expense_amount" type="number"></el-input>
                        </el-form-item>
                        <el-form-item  label="捆包号：" prop="bale_no" v-if="form_params.types==5">
                            <el-input v-model="form_params.bale_no"></el-input>
                        </el-form-item>
                        <el-form-item  label="申请原因：" prop="leave_reason" style="margin-bottom: 40px;">
                            <el-input class="textareaStyle" style="border-color: #a7a7a7;" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="form_params.leave_reason" ></el-input>
                            <!-- <textarea style="width: 140px;min-height: 60px;border-color: #a7a7a7;border-radius: 5px;color: #606266;" class="edit_input edit_textarea formInput" v-model="form_params.leave_reason">
                        </textarea> -->
                        </el-form-item>
                        <el-form-item  label="备注信息：" prop="remark">
                            <el-input v-model="form_params.remark"></el-input>
                        </el-form-item>
                        <el-form-item  label="关联文件：" prop="remark">
                            <!-- <el-input v-model="form_params.remark"></el-input> --><i class="iconfont icon-shangchuanwenjian2 returnImg"></i>
                            <span class="fontIcon" @click="uploadFileB">上传图片</span>
                        </el-form-item>
                    </div>
                    <div class="elFormBoxBtnListCol">
                        <el-button class="funcPublicBtn" @click="leavetriDialog=!leavetriDialog" style="margin-right:15px!important;">取消</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="updataType==2" style="width: 100px;" @click="saveOutFee">保存并提交审批</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked" v-else style="width: 100px;" @click="saveOutFee">修改</el-button>
                    </div>
                </el-form>
            </div>
        </el-dialog>
        <!--请假条END-->
        <!-- 上传文件 -->
        <!-- <el-dialog v-dialog-drag title="上传文件" :visible.sync="importFiles" class="eldialog eldialogA" :modal="false" width='500px'>
			<div class="text-center"  style="margin-top:20px;">
				<el-upload class="upload-demo" ref='upload_path' drag :action="oss.host" :data="upload_data" :on-success="handleSuccess" :before-upload="beforeUpload" accept=".xls,.xlsx,.txt,image/jpeg,image/png">
					<i class="el-icon-upload"></i>
					<div class="el-upload__text"  style="font-size:12px; color:#333;">将文件拖到此处，或<em style="color: #b21111;">点击上传</em></div>
				</el-upload>
			</div>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="filesYes">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="importFiles=!importFiles">取消</el-button>
            </div>
		</el-dialog> -->
        <!--请假审批START-->
        <el-dialog v-dialog-drag :visible.sync="examineDialog" class="eldialog eldialogLine" :modal="false" :title="statusJudge==0?'申请单审批':'OA申请单'" width="825px" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form ref="feeOutForm" :model="form_params" :rules="feeOutFormRlues" class="clearfix dialogFormB">
                    <div class="formItem">
                        <el-form-item  label="申请时间：" prop="operate_time" >
                            <el-date-picker v-model="form_params.operate_time" type="date" placeholder="" size="mini" disabled></el-date-picker>
                        </el-form-item>
                        <el-form-item  label=" 申请人：" prop="leave_people_id" >
                            <el-select v-model="form_params.leave_people_id" @visible-change="getSelectList('officeUsers')" disabled>
                                <el-option v-for="list in selectMap.officeUsers" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item  label="申请类型：" prop="types">
                            <el-select v-model="form_params.types" @visible-change="getSelectList('officeTypes')" disabled>
                                <el-option v-for="list in selectMap.officeTypes" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item  label="请假天数：" prop="leave_long" v-if="form_params.types==1">
                            <el-input v-model="form_params.leave_long" type="number"  disabled></el-input>
                        </el-form-item>
                        <el-form-item  label="客户名称：" prop="customer_name" v-if="form_params.types==2">
                            <el-input v-model="form_params.customer_name" disabled></el-input>
                        </el-form-item>
                        <!-- <el-form-item  label="关联单号：" prop="order_id" v-if="form_params.types==2">
                        <el-select v-model="form_params.order_id" @visible-change="getSelectList('officeOrder')" disabled>
                                <el-option v-for="list in selectMap.officeOrder" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item> -->
                        <el-form-item  label="预支金额：" prop="amount" v-if="form_params.types==3">
                            <el-input v-model="form_params.amount" type="number" disabled></el-input>
                        </el-form-item>
                        <el-form-item  label="报销金额：" prop="expense_amount" v-if="form_params.types==4">
                            <el-input v-model="form_params.expense_amount" type="number" disabled></el-input>
                        </el-form-item>
                        <el-form-item  label="申请原因：" prop="leave_reason" style="margin-bottom: 40px;">
                            <el-input class="textareaStyle" style="color: #333;background-color: #F5F7FA;" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="form_params.leave_reason" disabled></el-input>
                            <!-- <textarea disabled style="width: 140px;min-height: 60px;border-radius: 5px;color: #333;background-color: #F5F7FA;font-family: antialiased;" class="edit_input edit_textarea formInput" v-model="form_params.leave_reason">
                        </textarea> -->
                        </el-form-item>
                        <el-form-item  label="备注信息：" prop="remark">
                            <el-input v-model="form_params.remark" disabled></el-input>
                        </el-form-item>
                        <el-form-item  label="关联文件：" prop="remark">
                            <div style="display: flex;">
                                <!-- <i class="iconfont icon-shangchuanwenjian2 returnImg"></i> -->
                                <!-- <span class="fontIcon" @click="look(form_params)" :preview-src-list="form_params.files">查看图片</span> -->
                                <span style="font-size: 12px;color: #333;padding-left: 10px;" @click="look(form_params)" v-if="form_params.files.length==0">暂无图片</span>
                                <viewer :images="form_params.files" v-else> 
                                    <img v-for="(src,index) in form_params.files" v-show="index < 1" class="viewImg" :src="src.url" :key="index"/>
                                </viewer>
                            </div>
                        </el-form-item>
                    </div>
                    <div class="elFormBoxBtnListCol">
                        <el-button class="funcPublicBtn"  v-if="statusJudge==0" @click="refuseOpen" style="margin-right:15px!important;">拒绝</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked"  v-if="statusJudge==0" style="width: 100px;" @click="adopt">通过</el-button>
                        <el-button class="funcPublicBtn"  v-else style="width: 100px;" @click="examineDialog=!examineDialog">关闭</el-button>
                    </div>
                </el-form>
            </div>
        </el-dialog>
        <!--请假条审批END-->
        <!--拒绝原因START-->
        <el-dialog v-dialog-drag title="审核拒绝" :visible.sync="centerDialogVisible" class="eldialog eldialogA" width="400px!important" :model="false">
            <textarea class="edit_input edit_textarea" v-model="refuse_remark" placeholder="请输入拒绝原因"></textarea>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn"  @click="refuse">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="centerDialogVisible = false">取消</el-button>
            </div>
		</el-dialog>
        <!--拒绝原因END-->
        <relativeFile :dialog="downLoadFileDialog" @closeDialog="()=>{this.downLoadFileDialog = false}" :files="downFilesList"></relativeFile>
        <!-- 文件上传 START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleFile" class="eldialog eldialogOneLabel eldialogFileUpload" width="500px" :modal="false" title="文件上传" custom-class="full_dialog">
            <div class="upFileOutBox clearfix">
                <el-upload class="upload-demo" ref='upload_path' drag :action="oss.host" :data="upload_data" :on-success="handleSuccess" :before-upload="beforeUpload">
                    <img src="/icon/upfile.png" class="uploadFileAdd">
                    <div class="uploadTitle">点击文件上传</div>
                </el-upload>
                <div class="upFileBox clearfix" v-for="(item,index) in upFileList" :key="index+'_index'">
                    <div class="upFile">{{item.name}}</div>
                    <img src="/icon/top-delete-suspension.png" class="upFileRemove" @click="upFileRemove(item.url)"/>
                    <div class="upFileUnder"></div>
                    <div class="upFileTop"></div>
                    <div class="upFileLeft"></div>
                    <div class="upFileRight"></div>
                </div>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button  class="funcPublicBtn funcPublicBtnChecked dialogBtn" @click="saveFile">保存</el-button>
                <el-button class="funcPublicBtn dialogBtn" @click="dialogVisibleFile = false">关闭</el-button>
            </div>
        </el-dialog>
        <!-- 文件上传 END -->
        <!-- 文件上传 START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleFileB" class="eldialog eldialogOneLabel eldialogFileUpload" width="500px" :modal="false" title="文件上传" custom-class="full_dialog">
            <div class="upFileOutBox clearfix">
                <el-upload class="upload-demo" ref='upload_path' drag :action="oss.host" :data="upload_data" :on-success="handleSuccess" :before-upload="beforeUpload">
                    <img src="/icon/upfile.png" class="uploadFileAdd">
                    <div class="uploadTitle">点击文件上传</div>
                </el-upload>
                <div class="upFileBox clearfix" v-for="(item,index) in upFileList" :key="index+'_index'">
                    <div class="upFile">{{item.name}}</div>
                    <img src="/icon/top-delete-suspension.png" class="upFileRemove" @click="upFileRemove(item.url)"/>
                    <div class="upFileUnder"></div>
                    <div class="upFileTop"></div>
                    <div class="upFileLeft"></div>
                    <div class="upFileRight"></div>
                </div>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button  class="funcPublicBtn funcPublicBtnChecked dialogBtn" @click="determine">确定</el-button>
                <el-button class="funcPublicBtn dialogBtn" @click="dialogVisibleFileB = false">关闭</el-button>
            </div>
        </el-dialog>
        <!-- 文件上传 END -->
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="office.list" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
    </div>
</template>
<style scoped lang="scss">
    .dialog_path_title{text-align: center;font-size:14px; font-weight:bold; line-height:25px; color: #606266;padding-bottom:20px;background-color: #fff;}
    .search_box{padding-right:230px;}
    .execlInsert .excel_btn{display: inline;}
        .link_item{
            // padding-right: 50px;
            // margin:0 37px;      
            // margin-top:20px;
            position:relative;
        .item_icon{      
            position:absolute;
            right: 0px;
            top:26px;
            display: block;
            width: 25px;
            height: 25px;
        }
        .add_icon{           
            background: url(/icon/frame_plus.png) center center no-repeat;
            background-size: 16px 16px;
        }
        .del_icon{
            background: url(/icon/frame_minus.png) center center no-repeat;
            background-size: 16px 16px;
        }
        }
        .add_item{
            border-top: 1px dashed #aaa;
            margin-top: 0px;
            padding-top: 10px;
        }
        .file{
            width: 20px;
            float: left;
            margin-left: 5px;
            margin-top: 1px;
        }
        .mark{
            .content_box{
                width: 140px; 
                border-bottom: 1px solid #DCDFE6;
                display:flex;
                padding-left: 10px;
                .content{
                    flex: 1;
                    display: inline-block;
                    width: 120px;
                    height: 24px;
                    text-align:left;
                    overflow:hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-size: 12px;
                }
                .edit{
                    display:inline-block;
                    width:20px;
                    background: url(/icon/operation_edit.png) 100% 65% no-repeat;
                    background-size: 16px 16px;
                }         
            }
        }
    .upimgOutBox .uploadImageAdd{width:100%;height:100%;}
    .upimgOutBox .upload-demo{float: left;width:102px;height:102px;overflow: hidden;}
    .upimgOutBox .upImgBox{position: relative;width:102px;height:102px;float: left;margin-right:10px;margin-bottom:10px;position: relative;}
    .upimgOutBox .upImg{display: block;width:100%;height:100%;}
    .upimgOutBox .upImgRemove{width:20px;height:20px;position: absolute;top:5px;right:5px;cursor:pointer;}
    .returnImg{font-size: 16px;}
    .fontIcon{font-size: 12px;color: #b21111;padding-left: 10px;text-decoration:underline;cursor: pointer;}
    .formItem{background-color: #f0f6f5;padding: 20px 10px 70px 0;border-radius: 10px;}

    .eldialog.eldialogOneLabel /deep/ .el-form-item .el-form-item__content{width:160px;}

    .upimgOutBox .uploadImageAdd{width:100%;height:100%;}
    .upimgOutBox .upload-demo{float: left;width:102px;height:102px;overflow: hidden;}
    .upimgOutBox .upImgBox{position: relative;width:102px;height:102px;float: left;margin-right:10px;margin-bottom:10px;position: relative;}
    .upimgOutBox .upImg{display: block;width:100%;height:100%;}
    .upimgOutBox .upImgRemove{width:20px;height:20px;position: absolute;top:5px;right:5px;cursor:pointer;}
    .upFileOutBox .upFileBox{width:100%;margin-bottom:10px;border-radius: 5px;box-shadow: 0 0 5px #ccc;padding:2px 10px;margin-top:10px;}
    .upFileOutBox .upFile{display: block;float: left;font-size: 14px;}
    .upFileOutBox .upFileRemove{width:15px;height:15px;float:right;cursor:pointer;margin-top:2px;}
    .upFileOutBox .uploadFileAdd{width:60px;height:50px;display: block;margin:auto;margin-top:10px;}
    .upFileOutBox .upload-demo{width:100%;height:100px;overflow: hidden;}
    .upFileOutBox .uploadTitle{width:100%;text-align: center;font-size: 14px;margin-top:5px;color: #b21111;text-decoration: underline;}

    .upFileBox:hover{transform: translateY(-2px);cursor: pointer;}
    .upFileUnder{width:0;height:0;transition: 0.3s ease-out;position: absolute;right:0;margin: auto;bottom:0;border-radius: 35px;}
    .upFileTop{width:0;height:0;transition: 0.3s ease-out;position: absolute;left:0;margin: auto;top:0;border-radius: 35px;}
    .upFileLeft{width:0;height:0;transition: 0.3s ease-out;position: absolute;left:0;margin: auto;bottom:0;border-radius: 35px;}
    .upFileRight{width:0;height:0;transition: 0.3s ease-out;position: absolute;right:0;margin: auto;top:0;border-radius: 35px;}
    .upFileBox:hover .upFileUnder{width:100%;height:0;border-top:1px solid #b21111;}
    .upFileBox:hover .upFileTop{width:100%;height:0;border-top:1px solid #b21111;}
    .upFileBox:hover .upFileLeft{width:0;height:100%;border-left:1px solid #b21111;}
    .upFileBox:hover .upFileRight{width:0;height:100%;border-left:1px solid #b21111;}

</style>
<script>
    import pagination from '../../components/pagination.vue'
    import tabletem from '../../components/table.vue'
    import relativeFile from '../../components/downloadRelativeFile.vue';
    export default {
        components:{
            pagination,
            tabletem,
            relativeFile
        },
        data(){
            return{
                start_time: "",
                end_time: new Date(),
                tableLoading:false,
                module:localStorage.dw_erp_power_code,
                //导入 start
                importDialogVisible:false,
                upload_data : {},
				oss : {
                    host : "",
                },
				file_url : '',
                //导入 end
                isUpImg:0,
                dialogVisibleImg:false,
                upImgObj:{
                    ids:[],
                    files:[]
                },
                upImagesList:[],
                selectList:[],
                ruleForm:{
                    ids:[],
                    salesman_id:""
                },
                params:{
                    start_time:'',
                    end_time:'',
                    status:[],
                    apply_sn:'',
                    types:[],
                    leave_people_id:[],
                    reviewer_id:[],
                    bale_no:"",
                    leave_reason:'',
                    remark:'',
                    per_page: 50,
                    page:1
                },
                last_page: 1,
                current_page: 1,
                total: 0,
                updataType:2,//2新增，3修改
                list : [],
                // proList:[],
                cityList:[],
                cityListS:[],
                selectMap:{
                    officeUsers:[],
                    officeTypes:[],
                    officeOrder:[],
                    customerSource:[],
                    customerAttribute:[]
                },
                selectMapC:{
                    status:[],
                    types:[],
                    leave_people_id:[],
                    reviewer_id:[]                },
                // dialog START
                filterDialogVisible:false,
                filter:"",
                fields:"",
                form_params : {
                    operate_time: new Date(), 
                    types:'',
                    // leave_people_id: '', 
                    leave_people_id: localStorage.dw_erp_user_id ? parseInt(localStorage.dw_erp_user_id) : "",
                    leave_long:'',
                    customer_name:'',
                    // order_id:'',
                    amount:'',
                    expense_amount:'',
                    leave_reason:'',
                    remark:'',
                    files:[]
                },
                feeOutFormRlues:{
                    operate_time:[ { required: true, message: '请选择', trigger: 'blur' }],
                    types:[ { required: true, message: '请选择', trigger: 'blur' }],
                    leave_people_id:[ { required: true, message: '请选择', trigger: 'blur' }],
                    leave_long:[ { required: true, message: '请填写', trigger: 'blur' }],
                    leave_reason:[ { required: true, message: '请填写', trigger: 'blur' }],
                    amount:[ { required: true, message: '请填写', trigger: 'blur' }],
                    expense_amount:[ { required: true, message: '请填写', trigger: 'blur' }],
                    bale_no:[ { required: true, message: '请填写', trigger: 'blur' }],
                },
                tableCol:[	
                    {colName:"申请单",colKey:"apply_sn",colWidth:90,isSetWidth:true,isCanClick:true,isShow:true},
                    {colName:"申请时间",colKey:"operate_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"申请状态",colKey:"status_text",colWidth:190,isSetWidth:true,isCanClick:false,isColor:true,},
                    {colName:"申请类型",colKey:"types_text",colWidth:80,isSetWidth:true,isShow:true,isCanClickLocks:true},
                    {colName:"申请人",colKey:"leave_people_name",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"申请原因",colKey:"leave_reason",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"拒绝原因",colKey:"reject_reason",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"申请天数",colKey:"leave_long",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"预支金额",colKey:"amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"报销金额",colKey:"expense_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,},
                    {colName:"客户名称",colKey:"customer_name",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"关联文件",colKey:"images",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isStockImg:true,isColor:true},
                    {colName:"关联图片",colKey:"files",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isStockImgB:true,isColor:true},
                    // {colName:"关联图片",colKey:"files",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isRelativeFile:true,isColor:true},
                    // {colName:"关联单号",colKey:"order_sn",colWidth:100,isSetWidth:true,isShow:true,isCanClick:true,isColor:true,isHideShowClickImg:true,},
                    {colName:"审批人",colKey:"reviewer_name",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"捆包号",colKey:"bale_no",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"备注信息",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true}
                ],
                // dialog END
                // uploadExecl START
                show_upload : false,
                // uploadExecl END
                importFiles:false,
                markCopy: '',//备注复制
                isSeeEdit:false,    
                isShowMore:false,
                leavetriDialog:false,
                examineDialog:false,
                centerDialogVisible:false,
                refuse_remark:'',
                filesNum:0,
                downLoadFileDialog:false,
                downFilesList:[],
                officeOrderList:[],
                dialogVisibleFile:false,
                dialogVisibleFileB:false,
                upFileObj:{
                    ids:[],
                    files:[]
                },
                upFileList:[],
                viewer:1,
                statusJudge:99,
            }
        },
        created(){
            this.getSelectList("officeUsers");
            this.getSelectList("officeTypes");
            // this.getSelectList("customerSource")
            // this.getSelectList("customerAttribute")
            // this.getArea().then(resolve=>{
            //     this.proList=resolve.data.data;
            // })
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList();
        },
        methods:{
            getLeave_people_id(){
                this.officeOrderList =[];
                this.form_params.leave_people_id=''
            },
            getofficeOrderList(leave_people_id){
                this.postFunc('/erp/office.order.select',{leave_people_id:leave_people_id},res=>{
                    this.officeOrderList = res.data.data
                })
            },
            getSelectOAList(target){
                this.$getSelectOA(target,this.params).then(res=>{
                    this.selectMapC[res.data.data.target]=res.data.data.result;
                })
            },
            batchDel(){
                if(this.selectList.length<1){
                    this.tip("请选择数据","warning")
                }else{
                    this.$confirm('是否删除?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let arr = new Array();
                        this.selectList.forEach(item=>{
                            arr.push(item.id)
                        })
                        this.postFunc("/erp/office.delete",{ids:arr},()=>{
                            this.tip("删除成功","success")
                            this.getList();
                        },error=>{
                            this.tip(error.data.message,"warning")
                        })
                    }).catch(()=>{});
                }
            },

            uploadFile(){
                 if(this.selectList.length<1){
                    this.tip("请选择数据","warning")
                } else if(this.selectList.length>1){
                    this.tip("选择数量不能大于" + 1 + "条","warning")
                }else{
                    this.importFiles = true
                }
            },
            openFile(){
                 window.open(this.form_params.files)
            },
            exportExcelBill(){
                this.$exportExecl("/erp/office.list.export","请假条",this.params)
            },
            filterConfirm(){
                this.getList()
            },
            getSelectList(target){
                // if(target=="officeUsers"){
                //     this.$getSelectList(target).then(res=>{
                //         this.selectMap[res.target]=res.data
                //     }) 
                //     return
                // }
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            Examine(){
                if(this.selectList.length<=0){
                    this.tip("请选择数据","warning")
                }else{
                    this.$confirm('是否审批通过?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let arr = new Array();
                        this.selectList.forEach(item=>{
                            arr.push(item.id)
                        })
                        this.postFunc("/erp/office.reviews",{ids:arr},()=>{
                            this.tip("审批通过","success")
                            this.getList();
                        },error=>{
                            this.tip(error.data.message,"warning")
                        })
                    }).catch(()=>{});
                }
            },
            reset(){
                this.start_time='';
                this.end_time=new Date();
                this.params=this.resetSearch(this.params)
                this.getList()
            },
            selectChange(row){
                this.selectList=row;
            },
            del(id){
                this.$confirm('是否删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
                    this.postFunc("/erp/office.delete",{ids:[id]},()=>{
                        this.tip("删除成功","success")
                        this.getList();
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            openAddMatter(){
                this.updataType=2
                this.leavetriDialog = true;
                this.form_params = {
                    operate_time: new Date(), 
                    types:'',
                    leave_people_id: localStorage.dw_erp_user_id ? parseInt(localStorage.dw_erp_user_id) : "",
                    leave_long:'',
                    // order_id:'',
                    customer_name:'',
                    amount:'',
                    expense_amount:'',
                    leave_reason:'',
                    remark:'',
                    files:[]
                };
                this.upFileList = this.form_params.files?this.form_params.files:[];
            },
            saveOutFee(){
                this.$refs["feeOutForm"].validate((valid) => {
                    this.form_params.files = this.upFileList;
					if (valid) {
                        let operate_timea =this.form_params.operate_time;
                        this.form_params.operate_time=this.formatTimeZero(this.form_params.operate_time);
                        if(this.updataType==2){
                            this.postFunc("/erp/office.add",this.form_params,()=>{
                                this.tip("新增成功","success");
                                this.leavetriDialog = false;
                                this.getList();
                            },error=>{
                                this.tip(error.data.message,"warning")
                            })
                        }else{
                            this.postFuncLoading("/erp/office.edit",this.form_params,()=>{
                                this.tip("修改成功","success")
                                this.getList();
                                this.leavetriDialog=false;
                            },error=>{
                                this.form_params.operate_time = operate_timea;
                                this.tip(error.data.message,"warning")
                            })
                        }
					} else {
						return false;
					}
				});
            },
            edit(id){
                this.updataType=3
                this.leavetriDialog = true;
                this.postFunc('/erp/office.info',{id:id},res=>{
                    let resData = res.data.data
                    resData.types = resData.types === 0 ? '' : resData.types;
                    // resData.leave_time=this.formatTime(resData.leave_time+"000");
                    resData.operate_time=this.formatTime(resData.operate_time+"000");
                    this.form_params = res.data.data;
                    this.getofficeOrderList(this.form_params.leave_people_id);
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            rowClick(obj){
                if(obj.name==='apply_sn'){
                    this.getofficeOrderList(this.form_params.leave_people_id);
                    this.postFunc('/erp/office.info',{id:obj.id},res=>{
                        let resData = res.data.data
                        resData.types = resData.types === 0 ? '' : resData.types;
                        // resData.leave_time=this.formatTime(resData.leave_time+"000");
                        resData.operate_time=this.formatTime(resData.operate_time+"000");
                        this.form_params = res.data.data;
                        this.examineDialog = true;
                        this.statusJudge = obj.row.status;
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }
                if(obj.name==='files'){
                    window.open(obj.row.newFiles)
                }
            },
            //通过
            adopt(){
                this.postFunc('/erp/office.reviews',{ids:[this.form_params.id],action:1,},rs=>{
                    this.tip('审核通过',"success");
                    this.examineDialog = false;
                    this.getList();
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            //打开拒绝弹框
            refuseOpen(){
                this.centerDialogVisible = true
            },
            refuse(){
                 this.postFunc('/erp/office.reviews',{ids:[this.form_params.id],action:2,reject_reason:this.refuse_remark},rs=>{
                    this.tip('审核拒绝',"success");
                    this.centerDialogVisible=false;
                    this.examineDialog = false;
                    this.getList();
                    this.refuse_remark='';
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.tableLoading = true;
                this.params.start_time=this.formatTimeZero(this.start_time);
                this.params.end_time=this.formatTimeZero(this.end_time);
                this.$postColumnList("/erp/office.list",this.params,res=>{
                    this.last_page=parseInt(res.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.total);
                    this.list=res.data.data.data.data;
                    this.list.forEach((item,ind)=>{
                        item.baseColor = "";
                        if(item.status=='0'){
                            item.baseColor='red';
                        }else if(item.status=='1'){
                            item.baseColor='grey';
                        }else if(item.status=='2'){
                            item.baseColor='orange';
                        }
                        if(item.reject_reason==''){
                            item.reject_reason = "-";
                        }
                        if(item.leave_long==''){
                            item.leave_long = "-";
                        }else{
                            item.leave_long = item.leave_long+'天';
                        }
                        if(item.amount==''){
                            item.amount = "-";
                        }else{
                            item.amount = '￥'+item.amount;
                        }
                        if(item.expense_amount==''){
                            item.expense_amount = "-";
                        }else{
                            item.expense_amount = '￥'+item.expense_amount;
                        }
                        if(item.reviewer_name==''){
                            item.reviewer_name = "-";
                        }
                        if(item.customer_name==''){
                            item.customer_name = "-";
                        }
                        if(item.files==[]){
                            item.files = "-";
                        }
                        if(item.operate_time){
                            this.list[ind].operate_time = this.formatTime(this.list[ind].operate_time+"000")
                        }
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="status_text"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            look(obj){
                this.viewer= 2;
                //  this.relativeFile(obj);
            },
            relativeFile(obj){
                this.downLoadFileDialog = !this.downLoadFileDialog;
                if(obj.files!=null){
                    this.downFilesList = obj.files;
                }else{
                    this.downFilesList = '';
                }
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
            bacthUpImg(){
                if(this.selectList.length<1){
                    this.tip("请选择数据","warning")
                }else{
                    let arr = new Array();
                    this.selectList.forEach(item=>{
                        arr.push(item.id)
                    })
                    this.upImgObj.ids = arr;
                    if(this.selectList.length == 1){
                        this.upImagesList = Array.isArray(this.selectList[0].images)?JSON.parse(JSON.stringify(this.selectList[0].images)):[];
                    }
                    this.dialogVisibleImg = true;
                    this.isUpImg = 1;
                }
            },
            handleImagesSuccess(file){
                this.upImagesList.push(file.data.base_url);
            },
            upImgRemove(url){
                this.upImagesList.forEach((item,index)=>{
                    if(item == url){
                        this.upImagesList.splice(index,1)
                    }
                })
            },
            //导入 start
            handleSuccess(res) {
                // this.file_url = res.data.base_url;
				// this.$refs.upload_path.clearFiles();
                // this.tip('文件上传成功', 'success');
                // if(this.isUpImg == 2){
                    let obj = new Object();
                    obj.url = res.data.base_url;
                    obj.name = res.data.filename.substring(res.data.filename.lastIndexOf("/")+1,res.data.filename.length)
                    this.upFileList.push(obj)
                // }else{
                //     this.file_url = res.data.base_url;
                // }
				this.$refs.upload_path.clearFiles();
                this.tip('文件上传成功', 'success');
                //this.importFile();
            },
            beforeUpload(file) {
                this.file = file;
                return this.getOss();
            },
            //上传文件
            bacthUpFile(){
                if(this.selectList.length<1){
                    this.tip("请选择数据","warning")
                }else{
                    let arr = new Array();
                    this.selectList.forEach(item=>{
                        arr.push(item.id)
                    })
                    this.upFileObj.ids = arr;
                    if(this.selectList.length == 1){
                        this.upFileList = Array.isArray(this.selectList[0].files)?JSON.parse(JSON.stringify(this.selectList[0].files)):[];
                    }
                    this.dialogVisibleFile = true;
                }
            },
            uploadFileB(){
                this.filesNum=1;
                this.upFileList = this.form_params.files?this.form_params.files:[];
                this.dialogVisibleFileB = true;
            },
            upFileRemove(url){
                this.upFileList.forEach((item,index)=>{
                    if(item.url == url){
                        this.upFileList.splice(index,1)
                    }
                })
            },
            determine(){
                 this.dialogVisibleFileB = false;
            },
            //保存
            saveFile(){
                this.$confirm('是否确认上传?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.upFileObj.files = this.upFileList;
                    this.postFuncLoading("/erp/office.upload",this.upFileObj,()=>{
                        this.tip('上传成功','success');
                        this.dialogVisibleFile = false;
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            // filesYes(){
            //     let arr = []
            //     this.selectList.forEach(item=>{
            //         arr.push(item.id)
            //     })
            //     if(this.filesNum==1){
            //         arr=[this.form_params.id]
            //     }
            //     this.postFunc('/erp/office.upload',{ids:arr,files:[this.file_url]},()=>{
            //         this.tip("上传成功","success")
            //         this.getList()
            //         this.importFiles=false;
            //         this.filesNum=0,
            //         this.file_url='';
            //     })
            // },
            getOss(){
                let self = this;
                return new Promise((resolve, reject) =>{
                    window.axios.post(window.oss_url+"/tool/v1/oss.policy.get",{
                        operate_code : "shop-excel"
                    }).then((response) => {
                        if(response.data.code == 0){
                            self.oss = response.data.data;
                            this.upload_data = {
                                name: self.file.name,
                                key : self.oss.dir + "${filename}",
                                policy : self.oss.policy,
                                OSSAccessKeyId : self.oss.accessid,
                                success_action_status : "200",
                                callback : self.oss.callback,
                                signature : self.oss.signature,
                                'Cache-Control' : self.oss.cache_control,
                            }
                            resolve();
                        }
                    }).catch(()=>{
                        reject();
                    })
                })
            }
            //导入 end
        },
         watch:{
            // dialogVisible:function(val){
            //     if(!val){
            //         this.form_params = this.resetJson(this.form_params)
            //     }
            // },
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
        }
    }
</script>
